import { useEffect } from 'react';

import dayjs from 'dayjs';

import useFormContext from '@src/corelib/forms/generic/useFormContext';
import { getAbsencesIdsForRange, getUserAbsences } from '@src/pages/Absence/AbsenceTimeline/utils';
import { toUtcDate } from '@src/utils';

import useAbsencesTimeline from './../../../../hooks';
import { DatesRangeField } from './Dates';
import NotesField from './Notes';
import ReasonField from './Reason';
import TentativeField from './Tentative';
import TimeRangeField from './Time';

export default function EventFormFieldset({ data, hoursView }) {
  const { getValues, setValue, watch } = useFormContext();
  const { absences, setSelectedSlot} = useAbsencesTimeline();
  const [date_from, date_to] = watch(['date_from', 'date_to']);
  const [acti_start_time, acti_end_time] = watch(['acti_start_time', 'acti_end_time']);

  useEffect(() => {
    setSelectedSlot((slot) => ({
      ...slot,
      startTime: acti_start_time,
      endTime: acti_end_time,
    }));

  }, [acti_start_time, acti_end_time, setSelectedSlot]);


  useEffect(() => {
    if (date_from) {
      const start = dayjs(date_from);
      const end = date_to ? dayjs(date_to) : start;

      setSelectedSlot((slot) => ({
        ...slot,
        date_from: toUtcDate(start),
        date_to: toUtcDate(end),
        absences_ids: getAbsencesIdsForRange(
          start,
          end,
          getUserAbsences(slot.user_id, absences),
        ),
      }));
    }

  }, [absences, date_from, date_to, setSelectedSlot]);

  useEffect(() => {
    if (data) {
      const [date_from, date_to] = getValues(['date_from', 'date_to']);
      if (date_from && !date_from.isSame(data.date_from)) {
        setValue('date_from', data.date_from); 
      }
      if (date_to && !date_to.isSame(data.date_to)) {
        setValue('date_to', data.date_to);
      }

      const [acti_start_time, acti_end_time] = getValues(
        ['acti_start_time', 'acti_end_time'],
      );

      if (acti_start_time !== data.acti_start_time) {
        setValue('acti_start_time', data.acti_start_time || null);
      }
      if (acti_end_time !== data.acti_end_time) {
        setValue('acti_end_time', data.acti_end_time || null);
      }

      setValue('acti_type', data.acti_type);
      setValue('acti_tentative', data.acti_tentative);
      setValue('acab_notes', data.acab_notes || '');
    }

  }, [data, getValues, setValue]);

  return (
    <>
      <DatesRangeField hoursView={hoursView} />
      {hoursView && <TimeRangeField /> }
      <ReasonField />
      <TentativeField />
      <NotesField />
    </>
  );
}
